export enum LanguageDTO {
    ptBR = "ptBR",
    enUS = "enUS",
    esES = "esES"
}
